/***
*
*   ACCOUNT NAV
*   Acount sub nav that renders different options based
*   on user permissions. Shows billing & user admin to only account owners
*
**********/

import React, { useContext } from 'react';
import { NavLink } from "react-router-dom";
import { AuthContext } from 'components/lib';
import './sub.scss';

export function AccountNav(props){

  const context = useContext(AuthContext);

  return(
    <nav className='subnav'>

      <NavLink exact to='/account' activeClassName='active'>Perfil</NavLink>
      <NavLink exact to='/account/password' activeClassName='active'>Contraseña</NavLink>

      { context.permission?.owner &&
        <NavLink exact to='/account/billing' activeClassName='active'>Facturación</NavLink> }

      { context.permission?.admin &&
        <NavLink exact to='/account/users' activeClassName='active'>Usuarios</NavLink> }
      
      { context.permission?.owner &&
        <NavLink exact to='/account/crm' activeClassName='active'>ZOHO CRM</NavLink> }

      { context.permission?.owner &&
        <NavLink exact to='/account/settings' activeClassName='active'>Ajustes</NavLink> }

    </nav>
  );
}
